import customSelect from 'custom-select'
export default {
  name: 'custom-select',

  componentDidMount () {
    const customSelectEl = customSelect(this.el, {
      containerClass: 'custom-select-container',
      openerClass: 'custom-select-opener',
      panelClass: 'custom-select-panel',
      optionClass: 'custom-select-option',
      optgroupClass: 'custom-select-optgroup',
      isSelectedClass: 'is-selected',
      hasFocusClass: 'has-focus',
      isDisabledClass: 'is-disabled',
      isOpenClass: 'is-open',
    })

    const iconContainer = document.createElement('div')
    iconContainer.innerHTML = `
      <div class="custom-select-icon-wrapper">
        <svg width="13" height="8" viewBox="0 0 13 8">
          <path d="m1 1 5.5 5.25L12 1" stroke="#4F469C" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    `

    customSelectEl[0].container.appendChild(iconContainer.firstElementChild)

    if (this.props.hasPlaceholder) {
      customSelectEl[0].select.addEventListener('change', (e) => {
        if (e.target.value === '') {
          this.el.parentNode.parentNode.classList.add('has-placeholder')
        } else {
          this.el.parentNode.parentNode.classList.remove('has-placeholder')
        }
      })
    }
  },
}
